<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import CommentDetailList from '@/components/CommentDetailList.vue';
import DynamicTabs from '@/components/DynamicTabs.vue';
import FormVoteDetailList from '@/components/FormVoteDetailList.vue';

import { useCommentsStore, useFormsStore } from '@/stores';
import { Constants } from '@/constants';

// CONST
const { t } = useI18n();

// REFS
const activeTab = computed(() => {
  if (props.commentsEnabled) {
    return 'comments';
  } else if (form.value?.answers?.steps?.[0].otherChoice) {
    return 'otherChoices';
  } else if (form.value?.type === Constants.Form.Type.OpenQuestion) {
    return 'votes';
  }
  return '';
});

// STORE
const commentsStore = useCommentsStore();
const formsStore = useFormsStore();

// PROPS
const props = defineProps<{
  formId: number;
  commentsEnabled?: boolean;
}>();

// COMPUTED
const form = computed(() => formsStore.getItem(props.formId));

const tabs = computed(() => {
  const tabs = [];
  if (props.commentsEnabled) {
    tabs.push({ id: 'comments', name: t('form.tabs.comments'), icon: 'o_chat' });
  }
  if (form.value?.answers?.steps?.[0].otherChoice) {
    tabs.push({ id: 'otherChoices', name: t('form.tabs.otherChoices'), icon: 'o_fact_check' });
  }
  if (form.value?.type === Constants.Form.Type.OpenQuestion) {
    tabs.push({ id: 'votes', name: t('form.tabs.votes'), icon: 'o_fact_check' });
  }
  return tabs;
});

const comments = computed(() => commentsStore.getCommentsByFormId(props.formId));
const votes = computed(() => formsStore.getVotes(props.formId));
</script>
<template>
  <div class="form-analyze-tab">
    <dynamic-tabs :tabs="tabs" :active="activeTab" keep-alive>
      <template #comments>
        <comment-detail-list :comments="comments" />
      </template>
      <template #otherChoices>
        <form-vote-detail-list :votes="votes" />
      </template>
      <template #votes>
        <form-vote-detail-list :votes="votes" />
      </template>
    </dynamic-tabs>
  </div>
</template>
